import { NewdanhmucdangkiemService } from 'src/services/newdanhmucdangkiem.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const NEWDANHMUCDANGKIEM_NEW_CARE_SUCCESS = 'NEWDANHMUCDANGKIEM:NEW_CARE_SUCCESS'
export const NEWDANHMUCDANGKIEM_LIST_SUCCESS = 'NEWDANHMUCDANGKIEM:FIND_ALL_SUCCESS'
export const NEWDANHMUCDANGKIEM_LIST_FAILD = 'NEWDANHMUCDANGKIEM:FIND_ALL_FAILD'
export const NEWDANHMUCDANGKIEM_COUNT_ASSIGN_SUCCESS = 'NEWDANHMUCDANGKIEM:COUNT_ASSIGN_SUCCESS'
export const NEWDANHMUCDANGKIEM_COUNT_ASSIGN_FAILD = 'NEWDANHMUCDANGKIEM:COUNT_ASSIGN_FAILD'

export const NEWDANHMUCDANGKIEM_CREATE_SUCCESS = 'NEWDANHMUCDANGKIEM:CREATE_SUCCESS'
export const NEWDANHMUCDANGKIEM_CREATE_FAILD = 'NEWDANHMUCDANGKIEM:CREATE_FAILD'

export const NEWDANHMUCDANGKIEM_IMPORT_SUCCESS = 'NEWDANHMUCDANGKIEM:IMPORT_SUCCESS'
export const NEWDANHMUCDANGKIEM_SAVE_SUCCESS = 'NEWDANHMUCDANGKIEM:SAVE_SUCCESS'
export const NEWDANHMUCDANGKIEM_SAVE_FAILD = 'NEWDANHMUCDANGKIEM:SAVE_SUCCESS'

export const NEWDANHMUCDANGKIEM_DEL_SUCCESS = 'NEWDANHMUCDANGKIEM:DEL_SUCCESS'
export const NEWDANHMUCDANGKIEM_DEL_FAILD = 'NEWDANHMUCDANGKIEM:DEL_FAILD'

export const NEWDANHMUCDANGKIEM_ONE_SUCCESS = 'NEWDANHMUCDANGKIEM:FIND_ONE_SUCCESS'
export const NEWDANHMUCDANGKIEM_ONE_FAILD = 'NEWDANHMUCDANGKIEM:FIND_ONE_FAILD'

export const NEWDANHMUCDANGKIEM_HISTORY_LIST_SUCCESS = 'NEWDANHMUCDANGKIEM:HISTORY_FIND_ALL_SUCCESS'
export const NEWDANHMUCDANGKIEM_HISTORY_LIST_FAILD = 'NEWDANHMUCDANGKIEM:HISTORY_FIND_ALL_FAILD'

export const NEWDANHMUCDANGKIEM_UPDATE_FILTER = 'NEWDANHMUCDANGKIEM:NEWDANHMUCDANGKIEM_UPDATE_FILTER'

export const NEWDANHMUCDANGKIEM_LIST_EXPORT_SUCCESS = 'NEWDANHMUCDANGKIEM:FIND_ALL_EXPORT_SUCCESS'
export const NEWDANHMUCDANGKIEM_LIST_EXPORT_FAILD = 'NEWDANHMUCDANGKIEM:FIND_ALL_EXPORT_FAILD'

export const NEWDANHMUCDANGKIEM_UPDATE_HOMEPAGE_FILTER = 'NEWDANHMUCDANGKIEM:NEWDANHMUCDANGKIEM_UPDATE_HOMEPAGE_FILTER'

export const NEWDANHMUCDANGKIEM_HOMEPAGE_LIST_SUCCESS = 'NEWDANHMUCDANGKIEM:FIND_HOMEPAGE_LIST_SUCCESS'
export const NEWDANHMUCDANGKIEM_HOMEPAGE_LIST_FAILD = 'NEWDANHMUCDANGKIEM:FIND_HOMEPAGE_LIST_FAILD'

export const NEWDANHMUCDANGKIEM_HOMEPAGE_ONE_SUCCESS = 'NEWDANHMUCDANGKIEM:FIND_HOMEPAGE_ONE_SUCCESS'
export const NEWDANHMUCDANGKIEM_HOMEPAGE_ONE_FAILD = 'NEWDANHMUCDANGKIEM:FIND_HOMEPAGE_ONE_FAILD'

export const NEWDANHMUCDANGKIEM_ORDER_SUCCESS = 'NEWDANHMUCDANGKIEM:ORDER_SUCCESS'
export const NEWDANHMUCDANGKIEM_ORDER_FAILD = 'NEWDANHMUCDANGKIEM:ORDER_FAILD'

export const NEWDANHMUCDANGKIEM_GET_SIM_ANALYSIS_SUCCESS = 'NEWDANHMUCDANGKIEM:GET_SIM_ANALYSIS_SUCCESS'
export const NEWDANHMUCDANGKIEM_GET_SIM_ANALYSIS_FAILD = 'NEWDANHMUCDANGKIEM:GET_SIM_ANALYSIS_FAILD'

export const NEWDANHMUCDANGKIEM_HANDLE_IMPORT_ERRORS = 'NEWDANHMUCDANGKIEM:NEWDANHMUCDANGKIEM_HANDLE_IMPORT_ERRORS'

export const NewdanhmucdangkiemAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    sendOrder,
    getSimAnalysis,
}

function getSimAnalysis(number) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewdanhmucdangkiemService.getSimAnalysis(number).then((response) => {
                dispatch(success(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_GET_SIM_ANALYSIS_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_GET_SIM_ANALYSIS_FAILD, error } }
}

function updateHomepageFilter(payload) {
    return { type: NEWDANHMUCDANGKIEM_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { newdanhmucdangkiem } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageNewdanhmucdangkiemFilter } = newdanhmucdangkiem;
        const homepageNewdanhmucdangkiemPage = homepageNewdanhmucdangkiemFilter.homepageNewdanhmucdangkiemPage;
        const homepageNewdanhmucdangkiemLimit = homepageNewdanhmucdangkiemFilter.homepageNewdanhmucdangkiemLimit;

        return new Promise((resolve, reject) => {
            NewdanhmucdangkiemService.homepageList(homepageNewdanhmucdangkiemFilter).then((rs) => {
                if (!!homepageNewdanhmucdangkiemFilter && homepageNewdanhmucdangkiemFilter.homepageNewdanhmucdangkiemPage === 0) {
                    dispatch(success({
                        homepageNewdanhmucdangkiemItems: rs.data.values,
                        homepageNewdanhmucdangkiemTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucdangkiem.homepageNewdanhmucdangkiemItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageNewdanhmucdangkiemLimit * homepageNewdanhmucdangkiemPage; i < homepageNewdanhmucdangkiemLimit * homepageNewdanhmucdangkiemPage + homepageNewdanhmucdangkiemLimit; i++) {
                        if (typeof rsDataValues[i - homepageNewdanhmucdangkiemLimit * homepageNewdanhmucdangkiemPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageNewdanhmucdangkiemLimit * homepageNewdanhmucdangkiemPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageNewdanhmucdangkiemItems: uniqueItems,
                        homepageNewdanhmucdangkiemTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucdangkiemService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: NEWDANHMUCDANGKIEM_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      NewdanhmucdangkiemService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucdangkiemService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { newdanhmucdangkiem } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucdangkiemService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucdangkiem.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucdangkiemService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(NewdanhmucdangkiemAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: NEWDANHMUCDANGKIEM_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: NEWDANHMUCDANGKIEM_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucdangkiemService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { newdanhmucdangkiem } = getState();

            const { filter } = newdanhmucdangkiem;

            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucdangkiemService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: NEWDANHMUCDANGKIEM_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { newdanhmucdangkiem } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = newdanhmucdangkiem;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            NewdanhmucdangkiemService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucdangkiem.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: NEWDANHMUCDANGKIEM_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucdangkiemService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(NewdanhmucdangkiemAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: NEWDANHMUCDANGKIEM_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_SAVE_FAILD, error } }
}

function create(payload, creatingFromAway = false) {
    return dispatch => {
        if (!creatingFromAway) dispatch(AppAction.appLoading(true));
        NewdanhmucdangkiemService.create(payload).then((rs) => {
            dispatch(success(rs));
            if (!creatingFromAway) dispatch(NewdanhmucdangkiemAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng (số khung - số máy)!");
        }).finally(() => {
            if (!creatingFromAway) dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucdangkiemService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucdangkiemAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể cập nhật, có thể do trùng (số khung - số máy)!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucdangkiemService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucdangkiemAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_DEL_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucdangkiemService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucdangkiemService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(NewdanhmucdangkiemAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { newdanhmucdangkiem } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucdangkiemService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucdangkiem.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucdangkiemService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCDANGKIEM_ORDER_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCDANGKIEM_ORDER_FAILD, error } }
}